// src/data/initialStates.js

import { DifficultyLevel, QuestionType, CaseType, Industry } from "../enums";

// 1) Key Point (lowest building block)
export const initialKeyPoint = {
    id: 1,
    title: "",
    dataPoints: [],
};

// 2) Question State
export const initialQuestionState = {
    questionId: 1,
    question: "",
    type: QuestionType.STRUCTURE,
    difficulty: DifficultyLevel.EASY,
    expectedTime: "5-10",
    basicInformation: new Set([]),
    additionalInformation: new Set([]),
    keyPoints: [],
    // For math questions only:
    calculationFinalAnswer: "",
    calculationKeyPoints: {},
};

// 3) Create a function that returns an initial "Case"
export function getInitialCaseState() {
    const uniqueId = Date.now();
    return {
        id: uniqueId,
        title: "",
        difficulty: DifficultyLevel.EASY,
        tags: [],
        companies: [],
        industry: Industry.HEALTHCARE,
        caseType: CaseType.MARKET_ENTRY,
        isInterviewerLed: false,
        expectedTime: "30-45",
        caseContext: {
            caseId: uniqueId,
            additionalInformation: new Set([]),
            promptContext: "",
            promptQuestion: "",
            graph: "",
        },
        caseQuestions: [],
        keyPoints: [{ ...initialKeyPoint }],
    };
}
